import Noodl from '@noodl/noodl-sdk';
import App from './App';

const EditableTableNode = Noodl.defineReactNode({
  name: 'Notion Table',
  category: 'Custom',
  getReactComponent() {
    return App;
  },
  inputProps: {
    Headers: {
      type: 'array'
    },
    Items: {
      type: 'array'
    },
  },
  outputProps: {
    onChange: { type: 'array', fireable: true },  // Output data and signal
  },
  signals: {
    onChange: {
      displayName: 'Data Changed',
    }
  }
});

Noodl.defineModule({
  reactNodes: [EditableTableNode],
  nodes: [],
  setup() {}
});
